import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const modelAlertsTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      // Container and layout
      background: theme.color.surface[1],
      surface: theme.color.surface[2],
      surface5: theme.color.surface[5],
      border: theme.color.surface[4],
      header: theme.color.surface.cool[2],

      // Text colors
      textPrimary: theme.color.text.core['-primary'],
      textSecondary: theme.color.text.core['-secondary'],
      textTertiary: theme.color.text.core['-tertiary'],
      successText: theme.color.dataVis.qualitative['moss-2'],
      errorText: theme.color.dataVis.qualitative['magenta-2'],

      // Interactive states
      hover: theme.color.surface[3],
      primary: theme.color.dataVis.qualitative['blue-3'],
      success: theme.color.dataVis.qualitative['moss-3'],
      error: theme.color.dataVis.qualitative['magenta-3'],

      // Alert list
      alertItem: {
        background: theme.color.surface[0],
        selectedBg: theme.color.dataVis.qualitative['blue-1'] + '20',
        selectedBorder: theme.color.dataVis.qualitative['blue-3'],
        hover: theme.color.surface[3],
      },

      // Form
      form: {
        inputBg: theme.color.surface[0],
        inputBorder: theme.color.surface[4],
        labelColor: theme.color.text.core['-primary'],
      },

      // Deployment toggle
      deploymentToggle: {
        background: theme.color.focus[6],
        border: theme.color.focus[4],
        spacing: {
          xs: theme.size.spacing.xs,
        },
        radius: {
          medium: theme.size.radius['radius-medium'],
        },
      },
    },
  ]),
);
